













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FilterButton extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isActive!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterbutton/FilterButton.vue